import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { Row } from 'antd';

import Styles from './HeaderRow.module.scss';
import { THeaderRow } from './definitions';
import SearchBox from '../../Molecules/SearchBox';
import NavItem from '../../Molecules/NavItem';
import ButtonUserInformation from '../../Molecules/ButtonUserInformation';
import { joinClassnames } from 'helpers/classNames';
import SidebarMenuButton from '../../Molecules/SidebarMenuButton';

const HeaderRow: React.FC<THeaderRow> = ({
  dataAuth,
  isSearchOverlayOpen,
  setSearchOverlayOpen,
  onClickSidebarMenu,
  userId,
}) => {
  return (
    <Row
      justify="space-between"
      align="middle"
      className={joinClassnames(
        Styles['header-row'],
        isSearchOverlayOpen && Styles['hide'],
      )}
    >
      <SearchBox userId={userId} onClick={() => setSearchOverlayOpen(true)} />
      <NavItem />
      <SidebarMenuButton onClick={onClickSidebarMenu} />
      <ButtonUserInformation dataAuth={dataAuth} />
    </Row>
  );
};

export default HeaderRow;
